import React from "react";
import { Quotes, Star } from "@phosphor-icons/react";
import { useLang } from "../context/LanguageContext";
import { Reveal } from "./Reveal";

export const Testimonials = () => {
  const { t } = useLang();

  return (
    <section id="reviews" className="cfg relative py-16 md:py-24 bg-[#F7F7F5]" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-12 text-center max-w-2xl mx-auto">
          <Reveal>
            <p className="cfg-body text-[12px] font-semibold tracking-[0.25em] uppercase text-[#D4AF37] mb-3">{t.reviews.overline}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="cfg-display text-3xl md:text-5xl text-[#071B2F] tracking-tight">{t.reviews.title}</h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {t.reviews.items.map((r, i) => (
            <Reveal key={i} delay={i * 0.12} y={40}>
              <div className="h-full rounded-[24px] border border-[#071B2F]/10 bg-white p-8 hover:border-[#D4AF37]/50 shadow-[0_20px_50px_-35px_rgba(7,27,47,0.35)] transition-colors flex flex-col" data-testid={`review-card-${i}`}>
                <Quotes weight="fill" size={30} className="text-[#D4AF37]/40 mb-5" />
                <p className="cfg-body text-[#071B2F]/80 text-lg leading-relaxed flex-1">{r.q}</p>
                <div className="mt-7 pt-5 border-t border-[#071B2F]/8 flex items-center justify-between">
                  <div>
                    <p className="cfg-body text-[#071B2F] font-semibold">{r.n}</p>
                    <p className="cfg-body text-[#071B2F]/40 text-sm">{r.r}</p>
                  </div>
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, s) => <Star key={s} weight="fill" size={14} className="text-[#D4AF37]" />)}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
